import * as React from 'react';
import { DataGrid } from '@material-ui/data-grid';
import Actions from './Actions';

const DataTable = (props) => {
    const { allUsers, deleteUser } = props
    const columns = [
        {
            field: 'id',
            headerName: 'ID',
            width: 70,
        },
        {
            field: 'fullName',
            headerName: 'Full Name',
            description: 'This column has a value getter and is not sortable.',
            sortable: false,
            width: 200,
            valueGetter: (params) =>
                `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
        {
            field: 'role',
            headerName: 'Role',
            width: 140,
            valueGetter: (params) => params.row.optional && params.row.optional.role,
        },
        {
            field: 'groups',
            headerName: 'Groups',
            width: 250,
            valueGetter: (params) =>
                params.row.optional && params.row.optional.groups,
        },
        {
            field: 'codeWars',
            headerName: 'CodeWars Username.',
            width: 140,
            valueGetter: (params) =>
                params.row.optional && params.row.optional.username,
        },
        {
            field: 'source',
            headerName: 'Source',
            width: 140,
            valueGetter: (params) =>
                params.row.optional && params.row.optional.source,
        },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 140,
            renderCell: (params) => <Actions {...params} deleteUser={deleteUser} />
        },


    ];

    return <DataGrid rows={allUsers} columns={columns} autoHeight={true} pageSize={10} />
}

export default DataTable
